import React, { useState, useEffect, useCallback } from 'react';
import { Box, Button, Slide, useBreakpointValue } from '@chakra-ui/react';
import { globalHistory } from '@gatsbyjs/reach-router';
import { CloseIcon } from '@chakra-ui/icons';
import hamburger from '@assets/hamburger.svg';
import menuImage from '@assets/menu-image.svg';

const Flyout = ({ children, onClicked = () => {}, ...props }) => {
  const [isActive, setIsActive] = useState(false);
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  const handleMenuStateToggle = useCallback(() => {
    const nextActiveState = !isActive;

    setIsActive(nextActiveState);
    onClicked({
      isActive: nextActiveState
    });
  }, [isActive, onClicked]);

  useEffect(() => {
    return globalHistory.listen(() => {
      setIsActive(false);
      onClicked({
        isActive: false
      });
    });
  }, [onClicked]);

  return isDesktop ? (
    <Box {...props}>{children}</Box>
  ) : (
    <Box width="0" zIndex="1" position="absolute" left="1rem" {...props}>
      <Box
        display={{ lg: `none` }}
        minW="1.875rem"
        pt=".75rem"
        as="button"
        cursor="pointer"
        h="44px"
        w="44px"
        onClick={handleMenuStateToggle}>
        <img src={hamburger} alt="Open Menu" />
      </Box>
      <Slide
        in={isActive}
        direction="left"
        style={{
          transitionDuration: isActive ? `100ms` : `300ms`,
          transitionTimingFunction: isActive ? `ease-out` : `ease-in`
        }}>
        <Box
          bg="purple.400"
          position="absolute"
          top="0"
          left="0"
          pl={8}
          width="100%"
          height="100vh">
          <Button
            cursor="pointer"
            mt={8}
            mb={8}
            variant="link"
            h="44px"
            w="44px"
            onClick={handleMenuStateToggle}>
            <CloseIcon color="white" />
          </Button>
          {children}
        </Box>
        <Box
          position="absolute"
          right="0"
          top="0"
          width="29px"
          height="100vh"
          zIndex="2">
          <img src={menuImage} alt="ACNECIDE+PURIFIDE" />
        </Box>
      </Slide>
    </Box>
  );
};

export default Flyout;
